import { render, staticRenderFns } from "./NotesListView.vue?vue&type=template&id=5c89870f&scoped=true"
import script from "./NotesListView.vue?vue&type=script&lang=js"
export * from "./NotesListView.vue?vue&type=script&lang=js"
import style0 from "./NotesListView.vue?vue&type=style&index=0&id=5c89870f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c89870f",
  null
  
)

export default component.exports